var render = function () {
  var _vm$global$profile, _vm$global$profile2, _vm$global$profile3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isSignedIn ? _c('sign-in-dialog', {
    attrs: {
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.$nextTick(function () {
          return _vm.isSignedIn || _vm.$emit('input', false);
        });
      }
    }
  }, [_vm._v(" Please sign in to add a subscription ")]) : _vm.code == 'MULTI-USER' && !_vm.global.profile.org ? _c('org-sign-up-dialog', {
    attrs: {
      "value": true
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-card-subtitle', {
    staticClass: "warning--text font-weight-bold"
  }, [_vm._v("You must be an organization administrator to sign up for a multi-user subscription")])], 1) : _vm.code == 'MULTI-USER' && !_vm.global.profile.org_admin ? _c('confirm-dialog', {
    attrs: {
      "msg": "You must be an organization administrator to manage your organization's subscriptions. Please contact us with any questions: <a href='mailto:contact@ellacard.com'>contact@ellacard.com</a>",
      "primary": "Ok",
      "buttons": ['Ok'],
      "persistent": false,
      "resolve": function (btn) {
        return _vm.$emit('input', false);
      }
    }
  }) : _vm.code == 'SINGLE-USER' && _vm.global.profile.org ? _c('confirm-dialog', {
    attrs: {
      "msg": "You are a member of an Ellacard organization and cannot enroll in the single-user subscription plan. Please contact us with any questions: <a href='mailto:contact@ellacard.com'>contact@ellacard.com</a>",
      "primary": "Ok",
      "buttons": ['Ok'],
      "persistent": false,
      "resolve": function (btn) {
        return _vm.$emit('input', false);
      }
    }
  }) : _vm.loadAccountStatus.pending ? _c('v-dialog-loader', _vm._g(_vm._b({
    attrs: {
      "width": "500",
      "value": _vm.value
    }
  }, 'v-dialog-loader', _vm.$attrs, false), _vm.$listeners)) : _vm.activeSubscription ? _c('v-dialog', _vm._g(_vm._b({
    attrs: {
      "width": "500",
      "value": _vm.value
    }
  }, 'v-dialog', _vm.$attrs, false), _vm.$listeners), [_c('v-card', [_c('v-btn', {
    staticClass: "float-right mt-3 mr-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Unlimited subscription")]), _c('v-card-subtitle', {
    staticClass: "overline short"
  }, [_vm._v(_vm._s(_vm.code))]), _c('v-card-subtitle', {
    staticClass: "warning--text font-weight-bold"
  }, [_vm._v(" Your current subscription has not yet expired. Please go to "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_vm._v("your account")]), _vm._v(" to manage your current subscription. ")], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1) : _c('v-dialog-loader', _vm._g(_vm._b({
    attrs: {
      "width": "500",
      "loading": !_vm.didLoadPayment,
      "value": _vm.value
    }
  }, 'v-dialog-loader', _vm.$attrs, false), _vm.$listeners), [_c('v-card', [_c('v-btn', {
    staticClass: "float-right mt-3 mr-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Unlimited subscription")]), _c('v-card-subtitle', {
    staticClass: "overline short"
  }, [_vm._v(_vm._s(_vm.code))]), _vm.code == 'MULTI-USER' ? _c('v-card-subtitle', {
    staticClass: "warning--text font-weight-bold"
  }, [_vm._v(" Subscription will be applied to your organization ")]) : _vm._e(), _c('v-divider'), _vm.paymentIsLoading ? _c('v-progress-linear', {
    staticClass: "absolute",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm.code == 'MULTI-USER' && !((_vm$global$profile = _vm.global.profile) !== null && _vm$global$profile !== void 0 && _vm$global$profile.org) ? _c('v-card-text', {
    staticClass: "pt-6 error lighten-5"
  }, [_vm._v(" A multi-user subscription requires a business account ")]) : _vm.code == 'MULTI-USER' && (_vm$global$profile2 = _vm.global.profile) !== null && _vm$global$profile2 !== void 0 && _vm$global$profile2.org && !((_vm$global$profile3 = _vm.global.profile) !== null && _vm$global$profile3 !== void 0 && _vm$global$profile3.org_admin) ? _c('v-card-text', {
    staticClass: "pt-6"
  }, [_vm._v(" Only organization administrators can add a business subscription ")]) : _vm.code == 'MULTI-USER' ? _c('v-card-text', {
    staticClass: "pt-5"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "text--label-active mb-1"
  }, [_vm._v("Subscription cadence")]), _c('div', {
    staticClass: "btn-group"
  }, [_c('v-btn', {
    staticClass: "btn-group-right",
    attrs: {
      "input-value": _vm.cadence == 'MONTHLY'
    },
    on: {
      "click": function ($event) {
        _vm.cadence = 'MONTHLY';
      }
    }
  }, [_vm._v("Monthly")]), _c('v-btn', {
    staticClass: "btn-group-left",
    attrs: {
      "input-value": _vm.cadence == 'ANNUAL'
    },
    on: {
      "click": function ($event) {
        _vm.cadence = 'ANNUAL';
      }
    }
  }, [_vm._v("Annual")])], 1)]), _vm.code == 'MULTI-USER' ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "text--label-active mb-1"
  }, [_vm._v("Number of shared users")]), _c('v-select', {
    staticStyle: {
      "height": "36px"
    },
    attrs: {
      "dense": "",
      "solo": "",
      "hide-details": "",
      "items": _vm.TIERS
    },
    model: {
      value: _vm.adjustedTier,
      callback: function ($$v) {
        _vm.adjustedTier = $$v;
      },
      expression: "adjustedTier"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm.showSpecialOffer ? _c('v-card-text', {
    staticClass: "pt-5"
  }, [_vm.resolveConfirmPromo ? _c('v-dialog', {
    attrs: {
      "width": "300",
      "value": true
    },
    on: {
      "input": _vm.resolveConfirmPromo
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Gift card credit applied ")]), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-5"
  }, [_vm._v(" Add any gift card to your card using the gift card button in the \"Sign / design\" view. "), _c('div', {
    staticClass: "my-2 text-center"
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "fab": "",
      "x-small": "",
      "color": "green lighten-2"
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiWalletGiftcard)
    }
  })], 1)], 1), _vm._v(" Credit will be applied automatically on checkout. ")]), _c('v-divider'), _c('v-card-actions', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.resolveConfirmPromo
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "text--label-active red--text"
  }, [_vm._v("Special offer")]), _c('div', [_vm._v(" $10 gift card with purchase of single-user subscription. Credit applied automatically on purchase. ")])], 1) : _vm._e(), _c('payment', {
    staticClass: "pa-6",
    attrs: {
      "metadata": _vm.paymentMetadata,
      "loading": _vm.paymentIsLoading
    },
    on: {
      "update:loading": function ($event) {
        _vm.paymentIsLoading = $event;
      },
      "complete": _vm.onComplete,
      "loaded": function ($event) {
        _vm.didLoadPayment = true;
      }
    }
  }), _c('v-divider'), _c('v-card-text', {
    staticClass: "pa-4 caption font-italic"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_vm._v("Prefer to pay by invoice? Please contact us: "), _c('a', {
    attrs: {
      "href": _vm.mailto
    }
  }, [_vm._v("contact@ellacard.com")])]), _vm._v(" You will be billed automatically on " + _vm._s(_vm.paymentMetadata.cadence == 'ANNUAL' ? 'an annual' : 'a monthly') + " basis. You can manage your subscription preferences and cancel at any time from your account. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }